import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Skipback"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M20.25 21C20.1186 21.0009 19.9893 20.9673 19.875 20.9025L5.62497 12.6525C5.38999 12.5193 5.24476 12.2701 5.24476 12C5.24476 11.7299 5.38999 11.4807 5.62497 11.3475L19.875 3.09749C20.107 2.96352 20.3929 2.96352 20.625 3.09749C20.8579 3.232 21.001 3.48098 21 3.74999V20.25C21 20.6642 20.6642 21 20.25 21ZM7.5 12L19.5 18.9525V5.04749L7.5 12ZM1.5 3.00098H3V21.001H1.5V3.00098Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Skipback.vue"]]);
